import { render, staticRenderFns } from "./ComponentePlantilla.vue?vue&type=template&id=55420b61&scoped=true&"
import script from "./ComponentePlantilla.vue?vue&type=script&lang=js&"
export * from "./ComponentePlantilla.vue?vue&type=script&lang=js&"
import style0 from "./ComponentePlantilla.vue?vue&type=style&index=0&id=55420b61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55420b61",
  null
  
)

export default component.exports